import React, { useState } from "react";
import "./FXPollChart.css";
import i18next from "i18next";
import BigNumber from "bignumber.js";

interface Props {
  hc: string;
  data: [{ period: string; v: number; p: number }];
}

export const FXPollChart = ({ hc, data }: Props) => {
  const renderColumn = (period: string, negative: boolean) => {
    if (data) {
      let obj = [];
      let valign = "top";

      let max = 0;
      let p = 0;
      let v = 0;
      let displayP = "";
      let displayV = "";
      for (let i = 0; i < data.length; i++) {
        max = Math.max(max, Math.abs(data[i].p));
        if (data[i].period === period) {
          p = data[i].p;
          v = data[i].v;
        }
      }

      if ((negative && p <= 0) || (!negative && p >= 0)) {
        let h = (Math.abs(p) / max) * 250;

        let color = "#B51A25";

        if (p > 0) {
          color = "#0aa97d";
          valign = "bottom";
          displayP = "(" + new BigNumber(p).toFixed(2) + "%)";
          displayV = "+" + v;
        } else {
          displayP = new BigNumber(p).toFixed(2) + "%";
          displayV = v.toString();
        }

        if (negative) {
          obj.push(
            <div
              key={"FXPollChart-Bar"}
              className="FXPollChart-Column-Bar"
              style={{ background: color, height: h + "px" }}
            ></div>
          );
          obj.push(
            <div
              key={"FXPollChart-Value"}
              className="FXPollChart-Column-Text"
              style={{ color: "#B12832" }}
            >
              {displayV}
            </div>
          );
          obj.push(
            <div
              key={"FXPollChart-Percent"}
              className="FXPollChart-Column-Text"
              style={{ color: "#B12832" }}
            >
              {displayP}
            </div>
          );
        } else {
          obj.push(
            <div
              key={"FXPollChart-Percent"}
              className="FXPollChart-Column-Text"
              style={{ color: "#377D22" }}
            >
              {displayV}
            </div>
          );
          obj.push(
            <div
              key={"FXPollChart-Value"}
              className="FXPollChart-Column-Text"
              style={{ color: "#377D22" }}
            >
              {displayP}
            </div>
          );
          obj.push(
            <div
              key={"FXPollChart-Bar"}
              className="FXPollChart-Column-Bar"
              style={{ background: color, height: h + "px" }}
            ></div>
          );
        }
      }

      return (
        <div
          className="FXPollChart-Column-Value"
          style={{ verticalAlign: valign }}
        >
          {obj}
        </div>
      );
    }
  };

  return (
    <div className="FXPollChart">
      <div className="FXPollChart-Positive">
        <div className="FXPollChart-Column-Label">{hc}</div>
        {renderColumn("1M", false)}
        {renderColumn("3M", false)}
        {renderColumn("6M", false)}
        {renderColumn("1Y", false)}
      </div>
      <div className="FXPollChart-Axis">
        <div className="FXPollChart-Column-Label">
          {i18next.t("News.FXPoll.RWR", "")}
        </div>
        <div className="FXPollChart-Column-Value">
          {i18next.t("News.FXPoll.1M", "")}
        </div>
        <div className="FXPollChart-Column-Value">
          {i18next.t("News.FXPoll.3M", "")}
        </div>
        <div className="FXPollChart-Column-Value">
          {i18next.t("News.FXPoll.6M", "")}
        </div>
        <div className="FXPollChart-Column-Value">
          {i18next.t("News.FXPoll.1Y", "")}
        </div>
      </div>
      <div className="FXPollChart-Negative">
        <div className="FXPollChart-Column-Label"></div>
        {renderColumn("1M", true)}
        {renderColumn("3M", true)}
        {renderColumn("6M", true)}
        {renderColumn("1Y", true)}
      </div>
    </div>
  );
};
